import { Chip } from "@mui/material";
import { Link } from "react-router-dom";

const PlayerButton = (props) => {
  return (
    <Chip
      data-testid="playerButton"
      label="Player"
      component={Link}
      to={"/player/" + props.playerId}
      clickable
      variant="outlined"
      sx={{ m: 0.5 }}
    />
  );
};

export default PlayerButton;
